import DEFAULT_PALETTE_LIGHT from './Palette/default_light'
import DEFAULT_PALETTE_DARK from './Palette/default_dark'

import PORTAL_PALETTE_LIGHT from './Palette/portal_light'
import PORTAL_PALETTE_DARK from './Palette/portal_dark'

import DEFAULT_TYPOGRAPHY from './Typography/default'
import PORTAL_TYPOGRAPHY from './Typography/portal'

import DEFAULT_THEME from './default'
import PORTAL_THEME from './portal'

export const BASE_THEME = localStorage.getItem('theme.theme') ?? 'default'
export const BASE_MODE = localStorage.getItem('theme.mode') ?? 'light'

const LOADED = {
    palette: {
        default: {
            light: DEFAULT_PALETTE_LIGHT,
            dark: DEFAULT_PALETTE_DARK
        },
        portal: {
            light: PORTAL_PALETTE_LIGHT,
            dark: PORTAL_PALETTE_DARK
        }
    },
    typography: {
        default: DEFAULT_TYPOGRAPHY,
        portal: PORTAL_TYPOGRAPHY
    },
    theme: {
        default: DEFAULT_THEME,
        portal: PORTAL_THEME
    }
}

const THEME = {
    palette: LOADED.palette[BASE_THEME][BASE_MODE],
    typography: LOADED.typography[BASE_THEME],
    theme: LOADED.theme[BASE_THEME]
}

export default THEME